import React, { Component } from 'react';
import moment from 'moment-timezone';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';

import SentActions from '../Telehealth/List/Components/SentActions';
import ReadyActions from '../Telehealth/List/Components/ReadyActions';
import CanceledActions from '../Telehealth/List/Components/CanceledActions';
import ArchivedActions from '../Telehealth/List/Components/ArchivedActions';
import ScheduledActions from '../Telehealth/List/Components/ScheduledActions';
import CompletedActions from '../Telehealth/List/Components/CompletedActions';
import SearchComponent from './Components/SearchComponent';
import TodaysTelehalthsEmpty from './Components/TodaysTelehealthsEmpty'

import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { history } from '../../_helpers/history';
import { telehealthActions } from '../../_actions/telehealth.actions'
import { Link } from 'react-router-dom';
import RoomCard from '../Telehealth/List/Components/RoomCard';
import { AbilityContext } from '../../_contexts/AbilitiesContext';

const columns = [
  {
    name: 'Status',
    selector: 'status',
    width: '95px',
    sort: false,
    cell: row => {
      if (row.status === 'HOLD' || row.status === 'READY') {
        return <Link className="btn btn-success px-3 btn-sm" to={`/telehealth/${row.id}`}>Join</Link>
      }

      return <span className='badge badge-info text-uppercase'>{row.status}</span>
    }
  },
  {
    name: 'First Name',
    sort: false,
    cell: row => {
      if (row.userProfile) {
        return `${row.userProfile.firstName}`
      } else {
        return `${row.patientFirstName}`
      }
    }
  },
  {
    name: 'Last Name',
    sort: false,
    cell: row => {
      if (row.userProfile) {
        return `${row.userProfile.lastName}`
      } else {
        return `${row.patientLastName}`
      }
    }
  },
  {
    name: 'Appt. Time',
    sort: false,
    cell: row => {
      return moment.tz(row.appointmentDate.date, row.appointmentDate.timezone).local().format('LT')
    }
  },
  {
    name: 'Provider',
    sort: false,
    cell: row => {
      return `${row.doctor.firstName} ${row.doctor.lastName}`
    }
  },
  {
    name: 'Location',
    selector: 'location',
    grow: 2,
    sort: false,
    cell: row => {
      return row.providerGroup.name
    }
  },
  {
    name: 'Questionnaire',
    grow: 2,
    sort: false,
    cell: telehealth => {
      return telehealth.questionnaire.title
    }
  },
  {
    sort: false,
    grow: 3,
    style: { justifyContent: "left", paddingRight: 0, paddingLeft: 0 },
    cell: (telehealth) => {
      if (telehealth.status === 'SCHEDULED') {
        return <ScheduledActions telehealth={telehealth} />
      }
      if (telehealth.status === 'SENT') {
        return <SentActions telehealth={telehealth} />
      }
      if (telehealth.status === 'HOLD' || telehealth.status === 'READY') {
        return <ReadyActions telehealth={telehealth} />
      }
      if (telehealth.status === 'COMPLETED') {
        return <CompletedActions telehealth={telehealth} />
      }
      if (telehealth.status === 'ARCHIVED') {
        return <ArchivedActions telehealth={telehealth} />
      }
      if (telehealth.status === 'CANCELED') {
        return <CanceledActions telehealth={telehealth} />
      }
    }
  }
];

class TodaysTelehealthsTable extends Component {

  static contextType = AbilityContext

  constructor(props) {
    super(props)

    this.state = {
      initLoad: true
    }
  }

  componentDidMount() {
    if (this.props.currentUser.UserType.Name === 'Licensed') {
      const providerId = this.props.currentUser.Doctor.DoctorId;

      history.push(`/dashboard/telehealths?professional=${providerId}&time=${Date.now()}`);
    } else {
      this.loadData();

      this.loadRooms();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.props.collection.length > 0) {
        this.setState({ initLoad: false })
      }
      this.loadData();
      this.loadRooms();
    }
  }

  loadRooms() {
    const queryParams = queryString.parse(this.props.location.search);

    const searchParams = {
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      appointmentDate: moment().local().format('MM/DD/YYYY'),
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      appointmentType: this.props.currentUser.UserType.Name === 'Licensed' ? 'telehealth' : ''
    }

    this.props.dispatch(telehealthActions.searchRooms(searchParams));
  }

  loadData() {
    const queryParams = queryString.parse(this.props.location.search);

    const searchParams = {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      appointmentDate: moment().local().format('MM/DD/YYYY'),
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      appointmentType: this.props.currentUser.UserType.Name === 'Licensed' ? 'telehealth' : ''
    }

    this.props.dispatch(telehealthActions.searchTelehealths(searchParams));
  }

  hasRoomAccess() {
    return this.props.currentUser.UserType.Name === 'Licensed' || this.context.can('room-access', 'telehealth')
  }

  render() {
    const { isSearching, collection, rooms, total } = this.props;

    if (this.state.initLoad && isSearching) {
      return <Spinner animation="border" role="status" />
    }

    else if (this.state.initLoad && collection.length === 0 && rooms.length === 0) {
      return <TodaysTelehalthsEmpty />
    }

    else {
      return <div className="row">
        { this.hasRoomAccess() && this.props.rooms.map(room => {
          return <div key={room.id} className="col-4">
            <RoomCard room={room} />
          </div>
        })}

        { total > 0 &&        
        <div className="col-lg-12">
          <DataTable
            title="Today's Telehealths"
            subHeader
            overflowY
            subHeaderComponent={
              <SearchComponent
                location={this.props.location}
                handleClear={() => history.push('/dashboard/telehealths')}
                handleSearch={(params) => {
                  const { firstName, lastName, locationId, professional } = params;
                  history.replace(`/dashboard/telehealths?firstName=${firstName}&lastName=${lastName}&location=${locationId}&professional=${professional}`)
                }} />
            }
            data={collection}
            columns={columns}
            progressPending={isSearching}
            onChangePage={page => {
              const queryParams = queryString.parse(this.props.location.search);

              const firstName = queryParams.firstName || '';
              const lastName = queryParams.lastName || '';
              const location = queryParams.location ? parseInt(queryParams.location) : '';
              const professional = queryParams.professional ? parseInt(queryParams.professional) : '';

              history.replace(`/dashboard/telehealths?page=${page}&firstName=${firstName}&lastName=${lastName}&location=${location}&professional=${professional}`)

            }}
            striped={true}
            pagination={true}
            paginationServer={true}
            paginationTotalRows={total}
            paginationRowsPerPageOptions={[15]}
            paginationPerPage={15}
            noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
            customStyles={{ subHeader: { style: { padding: '0px' }, }, cells: { style: { fontSize: '14px', paddingTop: '.5em', paddingBottom: '.5em' }, }, }}
          />
        </div>
        }
      </div>
    }
  }
}

function mapStateToProps(state) {
  return {
    rooms: state.telehealth.rooms,
    alert: state.alert,
    total: state.telehealth.collection.collection ? state.telehealth.collection.total : 0,
    collection: state.telehealth.collection.collection ? state.telehealth.collection.collection.data : [],
    currentUser: state.user.currentUser,
    isSearching: state.telehealth.isSearching,
  };
}

export default connect(mapStateToProps)(TodaysTelehealthsTable);